import {
  colorBackgroundAlt,
  colorBaseNeutralWhite,
} from '@duxton-web/design-tokens/themes/light';
import { Divider, Flex, Layout } from '@duxton-web/ui';
import React, { useEffect, useState } from 'react';

import SmartCampaignContentVariantsForm from 'omega-rtc/components/form/ucd/SmartCampaignContentVariantsForm';
import SmartCampaignMetaDataForm from 'omega-rtc/components/form/ucd/SmartCampaignMetaDataForm';
import { useCreateSmartCampaign } from 'omega-rtc/components/container/CreateSmartCampaignProvider';

interface SmartCampaignCreateEditProps {
  configs: any;
  isEditMode: boolean;
}

const SmartCampaignCreateEdit = ({
  configs,
  isEditMode,
}: SmartCampaignCreateEditProps) => {
  const [contentVariantsContainer, setContentVariantsContainer] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const { primaryLanguageContentsInForm, isMystiqueCallPending } =
    useCreateSmartCampaign();
  /**
   * After user click “generate more”:
   * Automatically scroll to the top of the content variants.
   */
  useEffect(() => {
    if (
      isMystiqueCallPending &&
      primaryLanguageContentsInForm.lastRoundNumber > 0
    ) {
      if (contentVariantsContainer && contentVariantsContainer.scrollTo) {
        contentVariantsContainer.scrollTo(0, 0);
      }
      window.scrollTo(0, 0);
    }
  }, [isMystiqueCallPending]);

  const toggleSideBarCollapse = () => setIsCollapsed(!isCollapsed);

  return (
    <Layout
      style={{
        display: 'flex',
        width: '100%',
        height: '100%',
        backgroundColor: colorBaseNeutralWhite,
      }}
    >
      <div style={{ display: 'flex' }}>
        <Layout.Sider
          trigger={null}
          collapsible
          collapsed={isCollapsed}
          collapsedWidth={0}
          width={'448px'}
          style={{
            height: '92vh',
            overflowX: 'scroll',
            scrollbarWidth: 'thin',
            backgroundColor: colorBaseNeutralWhite,
          }}
        >
          <SmartCampaignMetaDataForm
            configs={configs}
            isEditMode={isEditMode}
          />
        </Layout.Sider>

        <Divider style={{ margin: 0, height: '100%' }} type="vertical" />
      </div>

      <Flex flex={1}>
        <div
          ref={setContentVariantsContainer}
          style={{
            height: '92vh',
            width: '100%',
            overflowX: 'scroll',
            scrollbarWidth: 'thin',
            backgroundColor: colorBackgroundAlt,
          }}
        >
          <SmartCampaignContentVariantsForm
            isCollapsed={isCollapsed}
            toggleSideBarCollapse={toggleSideBarCollapse}
          />
        </div>

        <Divider style={{ margin: 0, height: '100%' }} type="vertical" />
      </Flex>
    </Layout>
  );
};

export default SmartCampaignCreateEdit;
